import "@abb-connect/react-shared/styles/abb-icons.css";
import "@abb-connect/react-shared/styles/animations.css";
import "@abb-connect/react-shared/styles/theme.css";

import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

import {
  injectABBIconsFont,
  injectABBVoiceFont,
} from "@abb-connect/react-shared";

injectABBVoiceFont();
injectABBIconsFont();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
